import React from "react";
import { Link } from "react-router-dom";
import { updateNavigationMenu } from "./../actions/navigationMenuActions";
import { connect } from "react-redux";

export const ACTIVE_CLASS = "is-active";

export const NavbarItems = ({
  menuItems,
  updateNavigationMenu,
  selectedMenu
}) => {
  return (
    <React.Fragment>
      {menuItems.map((item, index) => (
        <li key={index} className="nav-item">
          <Link
            id={item.id}
            className={
              "nav-link " + (selectedMenu === item.menuName ? ACTIVE_CLASS : "")
            }
            data-menu={item.menuName}
            to={item.pathTo}
            onMouseOver={() =>
              updateNavigationMenu({ highlightedMenu: item.menuName })
            }
            onFocus={() =>
              updateNavigationMenu({ highlightedMenu: item.menuName })
            }
            onClick={() => {
              updateNavigationMenu({ isHamburgerMenuOpen: false });
            }}
          >
            {item.label}
          </Link>
        </li>
      ))}
    </React.Fragment>
  );
};

export const mapStateToNavbarItems = ({ navigationMenuReducer }) => ({
  selectedMenu: navigationMenuReducer.selectedMenu,
  menuItems: navigationMenuReducer.menuItems
});

export default connect(mapStateToNavbarItems, { updateNavigationMenu })(
  NavbarItems
);
